import { ElMessageBox } from 'element-plus';

export const isMobileViewport = () => window.innerWidth <= 768;

export const resolveAssetUrl = (filename) => `${window.location.origin}/assets/${filename}`;

export const resolveDownloadUrl = (filename) => {
  const base = (process.env.VUE_APP_DOWNLOAD_BASE_URL || '/downloads').replace(/\/+$/, '');
  const name = String(filename).replace(/^\/+/, '');
  return `${base}/${name}`;
};

export const triggerDownload = (url, filename) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  if (filename) {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const openInNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const confirmInstallPackageOnMobile = async () => {
  if (!isMobileViewport()) return true;

  await ElMessageBox.alert(
    '软件只能在PC上安装运行。请在电脑上访问我们的网站以下载安装包。',
    '提示',
    {
      confirmButtonText: '确定',
      type: 'warning',
    }
  );
  return false;
};
